<script>
  import NavBar from './components/NavBar.vue'
  export default {
    name: 'App',
    computed: {
      sourceImageHeader() {
        return window.innerWidth <= 768
          ? '/visuels/entete/entete-court-sans-villes.png'
          : '/visuels/entete/entete-large-sans-villes.png'
      },
    },
    components: { NavBar },
  }
</script>

<template>
  <div id="app">
    <header>
      <router-link to="/">
        <img
          id="entete"
          :src="sourceImageHeader"
          alt="Entête du site Pascal Chôve. Retour à l'accueil."
        />
      </router-link>
    </header>
    <NavBar />

    <div id="banniere-facebook">
      <a
        id="lien-facebook"
        href="https://www.facebook.com/pascalchove"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>FACEBOOK</span>
        <img id="logo-facebook" src="/visuels/facebook-f.png" alt=""
      /></a>
    </div>

    <main class="main-container column-container">
      <router-view />
    </main>
    <footer>
      <p>Pascal Chôve - Tous droits réservés</p>
    </footer>
  </div>
</template>

<style scoped lang="scss">
  #app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    font-family: 'Oswald', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  #entete {
    position: relative;
    vertical-align: top;
    width: 100%;
    min-height: 100px;
  }

  header {
    width: 100%;
  }

  .main-container {
    min-height: 100%;
    flex: 1;
  }

  footer {
    background-color: rgb(242, 242, 242);
    padding: 8px;
    margin-top: 2em;

    a {
      color: rgb(0, 0, 0);
      font-family: 'Oswald';
      font-size: 14px;
      font-weight: 400;
    }
  }

  #banniere-facebook {
    padding: 0.8em;
    position: absolute;
    top: 10%;

    width: 160px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    background-color: black;
    left: -116px;
    transition: all 0.6s ease-in;
  }

  #logo-facebook {
    height: 24px;
    margin-left: 32px;
    transform: translateY(12.5%);
  }

  #lien-facebook {
    font-size: 20px;
  }

  #banniere-facebook:hover {
    transform: translateX(106px);
  }
</style>
